var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 22 22"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.786 1H2.214C1.544 1 1 1.543 1 2.214v19.572C1 22.456 1.543 23 2.214 23H12.76v-8.508H9.895v-3.33h2.864V8.71c0-2.84 1.737-4.389 4.27-4.389a24.23 24.23 0 0 1 2.557.13v2.97H17.84c-1.38 0-1.65.651-1.65 1.615v2.12h3.3l-.428 3.332h-2.89V23h5.614c.67 0 1.213-.543 1.213-1.214V2.214A1.212 1.212 0 0 0 21.786 1Z",
    id: "Facebook_svg__a"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1 -1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#Facebook_svg__a"
  }))));
};
export default SvgFacebook;